<script>
    import { Line } from 'vue-chartjs'
    import reactiveChart from './reactiveChart.mixin';

    export default {
        extends: Line,
        mixins: [ reactiveChart ]
    }
</script>


// WEBPACK FOOTER //
// src/components/stats/charts/common/line.chart.vue